
define('text!libs/strand/src/shared/js/colors.html',[],function () { return '<script src="Colors.js"></script>';});

